var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('transition',{attrs:{"name":"fade"}},[(!!_vm.product)?_c('ProductsListAside',{attrs:{"product-data":_vm.product,"product-docs":"","scope":""}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }